module.exports = "./img/7e7df4ebe6a319293ac59d367e730de7.jpg";